import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef3fee1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card-header px-5 py-4 border-0"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center position-relative"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar w-100 w-md-unset" }
const _hoisted_8 = {
  class: "d-sm-flex justify-content-sm-end btns-dataTable w-100 w-md-unset",
  "data-kt-users-table-toolbar": "base"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_15 = {
  key: 5,
  class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-5 mb-2 mb-sm-0",
  id: "kt_lookup_drawer_toggle"
}
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_17 = { class: "fw-bolder mx-5" }
const _hoisted_18 = { class: "me-2" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "text-break"
}
const _hoisted_21 = {
  key: 2,
  class: "text-break"
}
const _hoisted_22 = { key: 3 }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "card-body pt-0 px-5" }
const _hoisted_25 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = ["id"]
const _hoisted_28 = {
  class: "text-start text-gray-500 fw-bold text-uppercase gs-0",
  role: "row"
}
const _hoisted_29 = {
  key: 0,
  class: "w-10px pe-2"
}
const _hoisted_30 = { class: "form-check form-check-sm form-check-custom form-check-solid me-3" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "text-gray-600" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_36 = ["value"]
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 1,
  class: "odd"
}
const _hoisted_39 = ["colspan"]
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_42 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!
  const _component_VZSort = _resolveComponent("VZSort")!
  const _component_VZModal = _resolveComponent("VZModal")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_vz_add_edit_modal = _resolveComponent("vz-add-edit-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-one", _ctx.cardClass])
  }, [
    (_ctx.cardHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.showSearch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", {
                    class: "svg-icon svg-icon-1 position-absolute ms-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
                  }, _hoisted_5),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control w-md-350px ps-13",
                    placeholder: _ctx.t('common.search'),
                    onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event))
                  }, null, 40, _hoisted_6), [
                    [_vModelText, _ctx.searchTerm]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateQuery(_ctx.localPagination))),
                type: "button",
                class: "btn bg-transparent position-relative d-block pe-0"
              }, _hoisted_10),
              _createVNode(_component_VZFilter, {
                options: _ctx.tableFilter,
                defaultFilter: _ctx.defaultFilter,
                viewName: _ctx.viewName,
                loading: _ctx.loading,
                onFilterChange: _ctx.filterChange,
                ref: "VZFilter"
              }, null, 8, ["options", "defaultFilter", "viewName", "loading", "onFilterChange"]),
              (_ctx.getSortOptions.length)
                ? (_openBlock(), _createBlock(_component_VZSort, {
                    key: 0,
                    dataLength: _ctx.data.length,
                    options: _ctx.getSortOptions,
                    viewName: _ctx.viewName,
                    onUpdateSort: _ctx.sortChange
                  }, null, 8, ["dataLength", "options", "viewName", "onUpdateSort"]))
                : _createCommentVNode("", true),
              (
              _ctx.hasPermission(_ctx.permission.create) &&
              !(
                _ctx.viewName === 'events' ||
                _ctx.viewName === 'forms' ||
                _ctx.viewName === 'userAccounts'
              ) &&
              _ctx.tableForm &&
              _ctx.addButtonText
            )
                ? _withDirectives((_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-5 mb-2 mb-sm-0",
                    id: "vz_datatable_create_button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createForm('Users')))
                  }, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.addButtonText), 1)
                  ], 512)), [
                    [_vShow, !_ctx.selectedForDelete.length]
                  ])
                : _createCommentVNode("", true),
              (_ctx.viewName === 'events' && _ctx.hasPermission(_ctx.permission.create))
                ? _withDirectives((_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-5 mb-2 mb-sm-0",
                    id: "vz_datatable_create_button",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('create-event')), ["stop"]))
                  }, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("Add Event")), 1)
                  ], 512)), [
                    [_vShow, !_ctx.selectedForDelete.length]
                  ])
                : _createCommentVNode("", true),
              (
              _ctx.viewName === 'userAccounts' && _ctx.hasPermission(_ctx.permission.create)
            )
                ? _withDirectives((_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: "#",
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-5 mb-2 mb-sm-0",
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#kt_modal_create_user_account`,
                    id: "vz_datatable_create_button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('create-user-account')))
                  }, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("pages.user.addUser")), 1)
                  ], 512)), [
                    [_vShow, !_ctx.selectedForDelete.length]
                  ])
                : _createCommentVNode("", true),
              (_ctx.viewName === 'forms' && _ctx.hasPermission(_ctx.permission.create))
                ? _withDirectives((_openBlock(), _createElementBlock("a", {
                    key: 4,
                    href: "#",
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary ms-5 mb-2 mb-sm-0",
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#kt_modal_create_form`,
                    id: "vz_datatable_create_button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('create-form')))
                  }, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("Add Form")), 1)
                  ], 512)), [
                    [_vShow, !_ctx.selectedForDelete.length]
                  ])
                : _createCommentVNode("", true),
              (_ctx.activityTab)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.t("common.activity")), 1))
                : _createCommentVNode("", true)
            ]),
            (
            _ctx.getShowDelete &&
            _ctx.selectedForDelete.length &&
            _ctx.hasPermission(_ctx.permission.delete)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.selectedForDelete.length), 1),
                    _createTextVNode(_toDisplayString(_ctx.t("selected")), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showBulkDeleteModal && _ctx.showBulkDeleteModal(...args)))
                  }, _toDisplayString(_ctx.t("common.deleteSelected")), 1),
                  _createVNode(_component_VZModal, {
                    id: `vz_modal_bulk_delete_${_ctx.viewName}`,
                    title: `${_ctx.t('common.confirmDelete')}`,
                    showDialog: _ctx.showDialog,
                    widthClass: 'width-550',
                    onModalClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDialog = false))
                  }, {
                    actions: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDialog = false))
                      }, _toDisplayString(_ctx.t("common.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.applyBulkDelete && _ctx.applyBulkDelete(...args))),
                        disabled: _ctx.deleteBtnLoading
                      }, _toDisplayString(_ctx.t("common.delete")), 9, _hoisted_23)
                    ]),
                    default: _withCtx(() => [
                      (_ctx.bulkDelete && _ctx.bulkDeleteTextForSections)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            innerHTML: _ctx.bulkDeleteTextForSections
                          }, null, 8, _hoisted_19))
                        : (_ctx.bulkDelete && _ctx.bulkDeleteTextForForms)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.bulkDeleteTextForForms), 1))
                          : (_ctx.bulkDelete && _ctx.bulkDeleteTextForEvents)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.bulkDeleteTextForEvents), 1))
                            : (_ctx.bulkDelete)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.bulkDeleteText), 1))
                              : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["id", "title", "showDialog"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("table", {
            class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "table align-middle table-hover table-row-bordered gy-3 kt_data_table dataTable no-footer"]),
            id: `vz_table_${_ctx.viewName}`,
            role: "grid"
          }, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_28, [
                (_ctx.getShowDelete && _ctx.hasPermission(_ctx.permission.delete))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "data-kt-check": "true",
                          "data-kt-check-target": "#kt_table_users .form-check-input",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.checkAll) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.checkAll]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (cell, i) => {
                  return (_openBlock(), _createElementBlock("th", _mergeProps({
                    key: i,
                    onClick: ($event: any) => (_ctx.sort(cell, cell.sortable)),
                    class: [
                      cell.name && 'min-w-125px',
                      cell.sortable !== false && 'sorting',
                      _ctx.tableHeaders.length - 1 === i && 'text-end',
                      _ctx.localCurrentSort === `${_ctx.getSortKey(cell)}desc` &&
                        'sorting_desc',
                      _ctx.localCurrentSort === `${_ctx.getSortKey(cell)}asc` &&
                        'sorting_asc',
                    ],
                    tabindex: "0",
                    rowspan: "1",
                    colspan: "1",
                    style: {"cursor":"pointer"}
                  }, cell.attrs), _toDisplayString(cell.name), 17, _hoisted_31))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_32, [
              (_ctx.getItems.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: _normalizeClass(["odd", 
                      _ctx.viewName == 'userRole' && _ctx.selectedIndexOfRow === i
                        ? 'bg-table-row-selected'
                        : ''
                    ]),
                      onClick: ($event: any) => (_ctx.handelSelectedRowItem(item, i))
                    }, [
                      (_ctx.getShowDelete && _ctx.hasPermission(_ctx.permission.delete))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              (_ctx.bulkDelete && _ctx.bulkDelete.key)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: item[_ctx.bulkDelete.key],
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedForDelete) = $event)),
                                    onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, _hoisted_36)), [
                                    [_vModelCheckbox, _ctx.selectedForDelete]
                                  ])
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (cell, i) => {
                        return (_openBlock(), _createElementBlock("td", _mergeProps({
                          key: i,
                          class: ["col-width", {
                          'text-end': _ctx.tableHeaders.length - 1 === i,
                        }],
                          style: `max-width: ${
                          _ctx.tableWidth / _ctx.tableHeaders.length
                        }px !important`
                        }, cell.attrs), [
                          _createElementVNode("span", {
                            "data-bs-toggle": "tooltip",
                            title: _ctx.getTooltipVal(cell.key, item[cell.key])
                          }, [
                            _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                              _createTextVNode(_toDisplayString(item[cell.prop]), 1)
                            ], true)
                          ], 8, _hoisted_37)
                        ], 16))
                      }), 128))
                    ], 10, _hoisted_33))
                  }), 128))
                : (!_ctx.loading && _ctx.getItems.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                      _createElementVNode("td", {
                        colspan: _ctx.tableHeaders.length,
                        class: "dataTables_empty"
                      }, _toDisplayString(_ctx.emptyTableText), 9, _hoisted_39)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_27)
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                (_ctx.enableItemsPerPageDropdown)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("select", {
                          name: "kt_customers_table_length",
                          class: "form-select form-select-sm",
                          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.localPagination.rowsPerPage) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PAGE_ITEM, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_43))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.localPagination.rowsPerPage]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.localPagination.page,
                  "onUpdate:current-page": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.localPagination.page) = $event)),
                  onCurrentChange: _ctx.currentPageChange,
                  "page-size": +_ctx.localPagination.rowsPerPage || 0,
                  layout: "prev, pager, next",
                  total: _ctx.localPagination.total,
                  "hide-on-single-page": true,
                  background: ""
                }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (
        _ctx.tableFormData &&
        (_ctx.hasPermission(_ctx.permission.create) || _ctx.hasPermission(_ctx.permission.update))
      )
      ? (_openBlock(), _createBlock(_component_vz_add_edit_modal, {
          key: 1,
          modelValue: _ctx.openAddEditModal,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.openAddEditModal) = $event)),
          viewName: _ctx.viewName,
          data: _ctx.tableFormDataObj,
          "append-to-body": _ctx.viewName == 'sites' ? true : false,
          onOnSubmit: _ctx.submit,
          onOnCancel: _ctx.cancel,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openAddEditModal = false))
        }, null, 8, ["modelValue", "viewName", "data", "append-to-body", "onOnSubmit", "onOnCancel"]))
      : _createCommentVNode("", true)
  ], 2))
}